import { analyticsTrackEvent } from '@core/utils/analytics';
import {
  EMAIL_COMPOSE_STARTED,
  EMAIL_CONFIG_COMPLETED,
  EMAIL_CONFIG_DISCONNECTED,
  EMAIL_CONFIG_STARTED,
  EMAIL_REPLY_STARTED,
  EMAIL_SEARCHED,
  EMAIL_SYNC_NOW_CLICKED,
  HOME_OUTLOOK_ITEM_TYPE,
  HOME_VIEW_ALL_CLICKED,
  HOME_WIDGET_ITEM_TYPE,
  NAVIGATION_SOURCE_HOME_PAGE,
  NAVIGATION_SOURCE_OUTLOOK,
} from '@core/constants/analytics';
import { trackHomeWidgetItemClicked } from '../common/analytics';

/**
 * Event-specific props only.
 * System props (platform, Browser, role, userId, etc.) are attached by the analytics SDK.
 */

const outlookWidgetProps = {
  itemType: HOME_WIDGET_ITEM_TYPE,
  navigationSource: NAVIGATION_SOURCE_OUTLOOK,
} as const;

const outlookHomePageProps = {
  itemType: HOME_OUTLOOK_ITEM_TYPE,
  navigationSource: NAVIGATION_SOURCE_HOME_PAGE,
} as const;

/** EMAIL_CONFIG_STARTED */
export const trackOutlookConnectClicked = () => {
  analyticsTrackEvent(EMAIL_CONFIG_STARTED, outlookWidgetProps);
};

/** EMAIL_CONFIG_COMPLETED */
export const trackOutlookConnected = () => {
  analyticsTrackEvent(EMAIL_CONFIG_COMPLETED, outlookWidgetProps);
};

/** EMAIL_CONFIG_DISCONNECTED */
export const trackOutlookDisconnected = () => {
  analyticsTrackEvent(EMAIL_CONFIG_DISCONNECTED, outlookWidgetProps);
};

/** EMAIL_COMPOSE_STARTED */
export const trackOutlookComposeClicked = () => {
  analyticsTrackEvent(EMAIL_COMPOSE_STARTED, outlookHomePageProps);
};

/** EMAIL_REPLY_STARTED */
export const trackOutlookReplyClicked = () => {
  analyticsTrackEvent(EMAIL_REPLY_STARTED, outlookHomePageProps);
};

/** EMAIL_SEARCHED */
export const trackOutlookSearched = () => {
  analyticsTrackEvent(EMAIL_SEARCHED, outlookHomePageProps);
};

/** EMAIL_SYNC_NOW_CLICKED */
export const trackOutlookRefreshClicked = () => {
  analyticsTrackEvent(EMAIL_SYNC_NOW_CLICKED, outlookWidgetProps);
};

/** HOME_VIEW_ALL_CLICKED */
export const trackOutlookViewAllClicked = (count: number) => {
  analyticsTrackEvent(HOME_VIEW_ALL_CLICKED, {
    ...outlookWidgetProps,
    count,
  });
};

/**
 * HOME_WIDGET_ITEM_CLICKED
 * Does not send email id/content — only list position when available.
 */
export const trackOutlookEmailOpened = (
  navigationSource: string,
  itemIndex?: number
) => {
  trackHomeWidgetItemClicked({
    navigationSource,
    itemType: HOME_OUTLOOK_ITEM_TYPE,
    itemIndex,
  });
};
